import React, { useState, useEffect, useMemo } from 'react'

import { useAdminNotification } from '@contexts/admin/AdminNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import InventoriesList from '@shared/inventories/InventoriesList'

import { inventoryService } from '@services/admin/inventoryService'
import { inventoryHoldService } from '@services/admin/inventoryHoldService'
import { inventoryTypeService } from '@services/admin/inventoryTypeService'

export default function AdminInventoriesList() {
  const { addJob } = useAdminNotification()

  const [inventoryTypes, setInventoryTypes] = useState([])

  useEffect(() => {
    let cancelled = false
    inventoryTypeService.fetchList()
      .then(res => {
        if (cancelled) return
        if (res?.success && Array.isArray(res.data)) {
          setInventoryTypes(res.data)
        }
      })
      .catch(console.error)
    return () => { cancelled = true }
  }, [])

  const inventoryTypeOptions = useMemo(() => {
    return inventoryTypes
      .filter(it => it.name)
      .map(it => ({ label: it.name, value: it.name }))
  }, [inventoryTypes])

  return (
    <div>
      <ListPageHeader
        basePath="/admin"
        items={['stocks', 'stocks.current']}
      />
      <InventoriesList
        role="admin"
        service={inventoryService}
        holdService={inventoryHoldService}
        addJob={addJob}
        inventoryTypeOptions={inventoryTypeOptions}
      />
    </div>
  )
}
